import { useHandler } from "@/hooks";
import { useInputStore, useRefInputStore } from "@/state/stores";
import { useEffect, useRef } from "react";
import { useIsNewProject } from "./useIsNewProject";

export function useTextChangeVisual() {
  const textareaRef = useRefInputStore(({ inputRef }) => inputRef);
  const messageLength = useInputStore(({ message }) => message.length);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  const isNewProject = useIsNewProject();

  const updateActiveState = useHandler((isTyping: boolean) => {
    const textarea = textareaRef.current;
    if (!textarea) {
      return;
    }
    textarea.dataset.fpIsActive = String(isTyping);
  });

  useEffect(() => {
    if (isNewProject) {
      updateActiveState(true);
      return;
    }

    clearTimeout(timeoutRef.current);

    updateActiveState(messageLength > 0);

    timeoutRef.current = setTimeout(() => updateActiveState(false), 2000);

    return () => clearTimeout(timeoutRef.current);
  }, [isNewProject, messageLength, updateActiveState]);
}
